// Copyright 2016 Sorama B.V.
/* eslint-disable @typescript-eslint/no-explicit-any */

import { IParameterizedValueConverter } from "aurelia-binding-ext";
import { NotSupportedError } from "errors/NotSupportedError";

export class NullToStringValueConverter implements IParameterizedValueConverter<string, any, string> {
    public toView(value: any, parameter: string): string {
        if (value) return value;
        else return parameter;
    }

    public fromView(value: string, parameter: string): any {
        throw new NotSupportedError(
            "Converting a string back to a possible null value is not supported in the NullToStringValueConverter."
        );
    }
}
